import type { App, ComputedRef } from 'vue'
import { computed, inject, isRef, ref } from 'vue'
import type { MaybeRef } from '@vueuse/core'

const pluginKey = 'app.plugin.meta-robots'

export type MetaRobots = {
    index: boolean
    follow: boolean
}
export type MetaRobotsPlugin = {
    robots: ComputedRef<MetaRobots>
    content: ComputedRef<string>
    set(robots: MetaRobots): void
    reset(): void
}

export function installMetaRobotsPlugin(
    app: App,
    options: {
        default: MaybeRef<MetaRobots>
    }
): MetaRobotsPlugin {
    const robots = isRef(options.default)
        ? ref(options.default.value)
        : ref(options.default)

    const plugin: MetaRobotsPlugin = Object.freeze({
        robots: computed(() => robots.value),
        content: computed(
            () =>
                `${robots.value.index ? 'index' : 'noindex'}, ${
                    robots.value.follow ? 'follow' : 'nofollow'
                }`
        ),
        set(r: MetaRobots): void {
            robots.value = r
        },
        reset(): void {
            robots.value = isRef(options.default)
                ? options.default.value
                : options.default
        },
    })

    app.provide(pluginKey, plugin)

    return plugin
}

export function useRobotsPlugin(): MetaRobotsPlugin {
    return inject(pluginKey) as MetaRobotsPlugin
}
